export { sendMetric, withRouteMetrics } from './semanticMetrics';
